import CollaborationService from './CollaborationService';
export default CollaborationService;
